/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * @constant 日志统计操作类型
 */
var TRACKER_TYPE = {
    CLICK: 'clicked',
    OPEN_PAGE: 'open_page',
    EVENT: 'event' // 事件
};

// tslint:disable
var getSDK = function () {
    var currentSdk = {
        // tslint:disable-next-line: no-empty
        request: function () { },
        // tslint:disable-next-line: no-empty
        httpRequest: function () { },
        // tslint:disable-next-line: no-empty
        getSystemInfoSync: function () { },
    };
    if (typeof wx === 'object') {
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = wx;
    }
    else if (typeof dd === 'object') {
        // dd 必须出现在 my之前，因为现在dd环境里也有my
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = dd;
    }
    else if (typeof my === 'object') {
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = my;
    }
    else if (typeof tt === 'object') {
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = tt;
    }
    else if (typeof qq === 'object') {
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = qq;
    }
    else if (typeof swan === 'object') {
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = swan;
    }
    else {
        throw new Error('Current platform is not supported by SLS web track, Pleace contack Aliyun SLS team.');
    }
    return currentSdk;
};
var sdk = getSDK();
var WebTracker = /** @class */ (function () {
    function WebTracker(opt) {
        var _this = this;
        var _a, _b;
        this.timer = null;
        this.time = 10;
        this.count = 10;
        this.arr = [];
        this.time = (_a = opt.time) !== null && _a !== void 0 ? _a : 10; //定义时间，number类型
        this.count = (_b = opt.count) !== null && _b !== void 0 ? _b : 10; //定义数据条数，number类型
        this.url = 'https://' + opt.project + '.' + opt.host + '/logstores/' + opt.logstore + '/track';
        this.opt = opt;
        if (opt.installUnloadHook && typeof opt.installUnloadHook === 'function') {
            opt.installUnloadHook(function () {
                _this.platformSend(_this.assemblePayload());
            });
        }
    }
    WebTracker.prototype.assemblePayload = function (arr) {
        if (arr === void 0) { arr = this.arr; }
        var payload = {
            __logs__: arr,
        };
        if (this.opt.tags) {
            payload.__tags__ = this.opt.tags;
        }
        if (this.opt.topic) {
            payload.__topic__ = this.opt.topic;
        }
        if (this.opt.source) {
            payload.__source__ = this.opt.source;
        }
        return JSON.stringify(payload);
    };
    WebTracker.prototype.platformSend = function (payloadStr) {
        if (this.opt.sendPayload && typeof this.opt.sendPayload === 'function') {
            this.opt.sendPayload(this.url, payloadStr);
        }
    };
    WebTracker.prototype.transString = function (obj) {
        var newObj = {};
        for (var i in obj) {
            if (typeof obj[i] == 'object') {
                newObj[i] = JSON.stringify(obj[i]);
            }
            else {
                newObj[i] = String(obj[i]);
            }
        }
        return newObj;
    };
    WebTracker.prototype.sendImmediateInner = function () {
        if (this.arr && this.arr.length > 0) {
            this.platformSend(this.assemblePayload());
            if (this.timer != null) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.arr = [];
        }
    };
    WebTracker.prototype.sendInner = function () {
        if (this.timer) {
            if (this.arr.length >= this.count) {
                clearTimeout(this.timer);
                this.timer = null;
                this.sendImmediateInner();
            }
        }
        else {
            var that_1 = this;
            if (this.arr.length >= this.count || this.time <= 0) {
                this.sendImmediateInner();
            }
            else {
                this.timer = setTimeout(function () {
                    that_1.sendImmediateInner();
                }, this.time * 1000);
            }
        }
    };
    WebTracker.prototype.send = function (originLog) {
        var obj = this.transString(originLog);
        this.arr.push(obj);
        this.sendInner();
    };
    WebTracker.prototype.sendImmediate = function (originLog) {
        var obj = this.transString(originLog);
        this.arr.push(obj);
        this.sendImmediateInner();
    };
    WebTracker.prototype.sendBatchLogs = function (originLogs) {
        var _c;
        var _this = this;
        var logs = originLogs.map(function (originLog) { return _this.transString(originLog); });
        (_c = this.arr).push.apply(_c, logs);
        this.sendInner();
    };
    WebTracker.prototype.sendBatchLogsImmediate = function (originLogs) {
        var _c;
        var _this = this;
        var logs = originLogs.map(function (originLog) { return _this.transString(originLog); });
        (_c = this.arr).push.apply(_c, logs);
        this.sendImmediateInner();
    };
    return WebTracker;
}());
function send(url, payload) {
    var request = sdk.request || sdk.httpRequest;
    request({
        url: url + "?APIVersion=0.6.0",
        method: 'POST',
        data: payload,
    });
}
var WebTrackerMini = /** @class */ (function (_super) {
    __extends(WebTrackerMini, _super);
    function WebTrackerMini(opt) {
        var _this = this;
        var superOpt = Object.assign({}, opt, {
            sendPayload: function (url, payload) {
                send(url, payload);
            },
        });
        _this = _super.call(this, superOpt) || this;
        return _this;
    }
    return WebTrackerMini;
}(WebTracker));

var FsSlsTracker = /** @class */ (function (_super) {
    __extends(FsSlsTracker, _super);
    function FsSlsTracker(initConfig, commonParam) {
        var _this = _super.call(this, initConfig) || this;
        _this.param = commonParam;
        return _this;
    }
    /**
     * @function 点击
     * @param {String} category 页面
     * @param {String} seed 唯一标志
     * @param {String | Object} ext 其他参数，字符串或json对象
     */
    FsSlsTracker.prototype.trackerClick = function (category, seed, ext) {
        var param = this.getCommonParam();
        var extObj = {};
        if (typeof ext === 'string') {
            extObj = { ext4: ext };
        }
        else if (typeof ext === 'object') {
            extObj = ext;
        }
        this.send(__assign(__assign({}, param), { Event: __assign(__assign({}, extObj), { category: category, seed: seed, behavior: TRACKER_TYPE.CLICK }) }));
    };
    /**
     * @function 页面
     * @param {String} category 页面
     * @param {String} seed 唯一标志
     * @param {String | Object} ext 其他参数，字符串或json对象
     */
    FsSlsTracker.prototype.trackerOpenPage = function (category, seed, ext) {
        var param = this.getCommonParam();
        var extObj = {};
        if (typeof ext === 'string') {
            extObj = { ext4: ext };
        }
        else if (typeof ext === 'object') {
            extObj = ext;
        }
        this.send(__assign(__assign({}, param), { Event: __assign(__assign({}, extObj), { category: category, seed: seed, behavior: TRACKER_TYPE.OPEN_PAGE }) }));
    };
    /**
     * @function 事件
     * @param {String} category 页面
     * @param {String} seed 唯一标志
     * @param {String | Object} ext 其他参数，字符串或json对象
     */
    FsSlsTracker.prototype.trackerEvent = function (category, seed, ext) {
        var param = this.getCommonParam();
        var extObj = {};
        if (typeof ext === 'string') {
            extObj = { ext4: ext };
        }
        else if (typeof ext === 'object') {
            extObj = ext;
        }
        this.send(__assign(__assign({}, param), { Event: __assign(__assign({}, extObj), { category: category, seed: seed, behavior: TRACKER_TYPE.EVENT }) }));
    };
    /**
     * @func 追踪记录原始日志
     * @param [any] data 记录原始提示
     */
    FsSlsTracker.prototype.trackerLog = function (data) {
        var param = this.getCommonParam();
        this.send(__assign(__assign({}, param), data));
    };
    /**
     * @function 获取公共参数
     * @returns {any} 返回参数
     */
    FsSlsTracker.prototype.getCommonParam = function () {
        if (this.param) {
            return typeof this.param.data === 'function' ? this.param.data() : this.param;
        }
    };
    return FsSlsTracker;
}(WebTrackerMini));

export { FsSlsTracker as default };
//# sourceMappingURL=index.es5.js.map
